import React from "react";
import html2canvas from "html2canvas";
import * as jsPDF from "jspdf";
window.html2canvas = html2canvas;

const GenericPdfDownloader = ({ rootElementId, downloadFileName }) => {
  const downloadPdfDocument = async () => {
    const input = document.getElementById(rootElementId);
    if (!input) return;

    const images = input.querySelectorAll("img");
    await Promise.all(
      Array.from(images).map((img) => {
        if (!img.complete) {
          return new Promise((resolve) => {
            img.onload = resolve;
            img.onerror = resolve;
          });
        }
        return Promise.resolve();
      })
    );

    html2canvas(input, { useCORS: true }).then((canvas) => {
      const imgData = canvas.toDataURL("image/jpeg", 1.0);

      canvas.width = document.body.clientWidth;
      const pdf = new jsPDF("p", "mm", "a4");
      pdf.addImage(imgData, "JPEG", 10, 10, 190, 270);
      const imgWidth = 190;
      const pageHeight = 295;
      const imgHeight = (canvas.height * imgWidth) / canvas.width;
      let heightLeft = imgHeight;
      let position = 10;

      pdf.addImage(imgData, "JPEG", 10, position, imgWidth, imgHeight);
      heightLeft -= pageHeight;

      while (heightLeft > 0) {
        position = heightLeft - imgHeight;
        pdf.addPage();
        pdf.addImage(imgData, "JPEG", 10, position, imgWidth, imgHeight);
        heightLeft -= pageHeight;
      }

      pdf.save(`${downloadFileName}.pdf`);
    });
  };

  return (
    <button
      className="btn btn-default align-self-center d-none d-md-flex"
      style={{
        color: "#1782F4",
        //   border: '3px solid #00f',
        borderRadius: "5px !important",
        background: "#fff",
      }}
      onClick={downloadPdfDocument}
    >
      <strong>Print PDF</strong>
    </button>
  );
};

export default GenericPdfDownloader;
